<template>
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox" :class="{ 'expanded': expanded, 'search-bar': searchBarClassProp }">
          <header class="ibox-title" @click="toggleAccordion">
            <h5 class="ibox-documents-title">
              <i v-if="titleIcon" :class="titleIcon"></i>
              {{title}}
            </h5>
            <slot name="label"></slot>
            <div class="ibox-tools">
              <a>
                <span class="icon">
                  <i :class="chevronClass"></i>
                </span>
              </a>
            </div>
          </header>
          <div class="content">
            <div class="ibox-content">
              <slot name="content"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: "Accordion",

    props: {
      title: {
        type: String,
        required: true
      },
      titleIcon: {
        type: String
      },
      expandedProp: {
        type: Boolean,
        default: false
      },
      searchBarClassProp: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      expanded: false
    }),

    mounted () {
      if (this.expandedProp) {
        this.expanded = true
      }
    },

    methods: {
      toggleAccordion() {
        this.expanded = !this.expanded;
      },
    },

    computed: {
      chevronClass () {
        if(this.expanded){
          return "fa fa-chevron-up"
        } else {
          return "fa fa-chevron-down"
        }
      }
    }
  }
</script>

<style scoped>
    .ibox {
      margin-bottom: 25px;
    }
    .ibox .ibox-title {
      cursor: pointer;
    }
    .ibox .content {
      max-height: 0;
      overflow: hidden;
      transition: max-height .4s ease-in-out;
    }
    .ibox.expanded .content {
      max-height: 200vh;
    }
</style>